import React, { useEffect, useRef } from "react";
import editNumber from "../asset/images/revamp-images/editImg.svg";

const OtpInput = ({ otpValues, setOtpValues, onVerify, otpBtn, seconds, minutes,
    onOtpComplete, mobileNo, mobNumber, handleMobNumber }) => {
    //   const inputRefs = useRef([]);

    useEffect(() => {
        if (otpValues.every((val) => val !== "")) {
            onOtpComplete(true);
        } else {
            onOtpComplete(false);
        }
    }, [otpValues]);

    useEffect(() => {
        if (otpValues.every((val) => val === "")) {
            const firstInput = document.getElementById("otp-input-0");
            if (firstInput) firstInput.focus();
        }
    }, [otpValues]);

    const handleInput = (e, index) => {
        const value = e.target.value.replace(/\D/g, "");

        if (value.length <= 1) {
            const newOtpValues = [...otpValues];
            newOtpValues[index] = value;
            setOtpValues(newOtpValues);

            if (index < 3 && value) {
                document.getElementById(`otp-input-${index + 1}`).focus();
            }
        }
    };

    // const handleKeyDown = (e, index) => {
    //     if (e.key === "Backspace" && !otpValues[index] && index > 0) {
    //         document.getElementById(`otp-input-${index - 1}`).focus();
    //     }
    //     if (e.key === "Enter" && otpValues.every((val) => val !== "")) {
    //         handleVerifyData();
    //     }
    // };

    const handleKeyUp = (e, index) => {
        if (e.key === "Backspace") {
            if (!e.target.value && index > 0) {
            const prevInput = document.getElementById(`otp-input-${index - 1}`);
            if (prevInput) prevInput.focus();
        }
        }

        if (e.key === "Enter" && otpValues.every((val) => val !== "")) {
            handleVerifyData();
        }
    };

    const handleVerifyData = () => {
        const otp = otpValues.join("");
        onVerify(otp);
    };

    return (
        <div className="otp-wrapper">
            <div className="wrap-otp-content">
                <p className="otp-enter">Enter OTP</p>
                <p className="otp-enter">
                    <div className="countdown-text">
                        <div
                            className="btn-text-wrap"
                            disabled={seconds > 0 || minutes > 0}
                            style={{
                                color:
                                    seconds > 0 || minutes > 0
                                        ? "#92929291"
                                        : "rgba(49, 49, 49, 1)",
                            }}
                        >
                            <button
                                className="btn-resend"
                                disabled={seconds > 0 || minutes > 0}
                                style={{
                                    color:
                                        seconds > 0 || minutes > 0
                                            ? "#92929291"
                                            : "#0069B4",
                                }}
                                onClick={otpBtn}
                            >
                                Resend OTP
                            </button>
                            <p className="otpnumber">in</p>
                        </div>
                        {seconds > 0 || minutes > 0 ? (
                            <p>
                                {minutes < 10 ? `0${minutes}` : minutes}:
                                {seconds < 10 ? `0${seconds}` : seconds}
                            </p>
                        ) : (
                            <p className="otpnumber">00:00</p>
                        )}
                    </div>
                </p>
            </div>

            <div>
                <form id="otp-form">
                    <div className="form-group">
                        {[...Array(4)].map((_, index) => (
                            <div className="" key={index}>
                                <input
                                    type="text"
                                    id={`otp-input-${index}`}
                                    className="otp-form-control"
                                    pattern="[0-9]*"
                                    inputMode="numeric"
                                    maxLength={1}
                                    value={otpValues[index]}
                                    onChange={(e) => handleInput(e, index)}
                                    onKeyUp={(e) => handleKeyUp(e, index)}
                                    autoFocus={index === 0}
                                />
                            </div>
                        ))}
                    </div>
                </form>
            </div>
            <div className="otpsent-content">
                <p>
                    OTP sent to{" "}
                    <p className="number">
                        +91 {(mobileNo !== undefined || null) ? mobileNo : mobNumber}
                    </p>
                    {mobileNo == null ? (
                        <div
                            className="wrap-edit"
                            onClick={handleMobNumber}
                        >
                            <img
                                alt="edit icon"
                                className="edit-number"
                                src={editNumber}
                            />

                            <p className="edit-number">Edit</p>
                        </div>
                    ) : (
                        ""
                    )}
                </p>
            </div>
        </div>
    );
};

export default OtpInput;